import axios from 'axios';

const API = process.env.VUE_APP_API_URL;

let service = {
    authorize: (data) => {
        return axios.post(API + '/snelstartv2/authorize', data);
    },
    hasCredentials: (id) => {
        return axios.post(API + '/snelstartv2/has_credentials', {project_id: id});
    },
    clearCredentials: (id) => {
        return axios.post(API + '/snelstartv2/clear_credentials', {project_id: id});
    }
};

export default service;
